module.exports = "<a class=toogle-control ng-click=togglerCtrl.toggle() ng-class=\"{active: togglerCtrl.isOpened}\"><span ng-show=togglerCtrl.isOpened ng-bind=togglerCtrl.labelShownTranslated></span> <span ng-show=!togglerCtrl.isOpened ng-bind=togglerCtrl.labelTranslated></span></a>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common/widgets/toggler/toggler.html
// module id = 811
// module chunks = 0